import script from "./ParticleBall.vue?vue&type=script&setup=true&lang=js"
export * from "./ParticleBall.vue?vue&type=script&setup=true&lang=js"

import "./ParticleBall.vue?vue&type=style&index=0&id=4dacb51c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4dacb51c"]])

export default __exports__